// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dSAv7m1r7rr2rCPe9B4F {
  width: 98%;
}

.mC4Q0IUuXva3h9eyHVLd {
  padding-left: 0;
}

.mC4Q0IUuXva3h9eyHVLd > div {
  width: 100%;
}

.IVQQHbyCcHCS3NXAgT3G {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red"]};
}

.VD48os8ZB1DaFLfqsVtl {
  margin-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/InputPhone/InputPhone.module.css"],"names":[],"mappings":"AAGA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mDAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value base-purple, purple-lighten-5, base-dark-grey, color-red from colors;\n\n.phoneInput {\n  width: 98%;\n}\n\n.inputPhoneContainer {\n  padding-left: 0;\n}\n\n.inputPhoneContainer > div {\n  width: 100%;\n}\n\n.error {\n  color: color-red;\n}\n\n.iconError {\n  margin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"base-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["base-purple"]}`,
	"purple-lighten-5": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple-lighten-5"]}`,
	"base-dark-grey": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["base-dark-grey"]}`,
	"color-red": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red"]}`,
	"phoneInput": `dSAv7m1r7rr2rCPe9B4F`,
	"inputPhoneContainer": `mC4Q0IUuXva3h9eyHVLd`,
	"error": `IVQQHbyCcHCS3NXAgT3G`,
	"iconError": `VD48os8ZB1DaFLfqsVtl`
};
export default ___CSS_LOADER_EXPORT___;
